export const getAllAssets = async () => {
  const images = await import.meta.glob(
    "../images/**/*.{png,jpg,jpeg,webp,avif,svg}",
    {
      as: "url",
      assert: {
        type: "image",
      },
    }
  )

  return await Promise.all(Object.values(images).map((item) => item()))
}
